import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Apiservice from "../Apiservice";

const SalariedStaffs = () => {
  const navigate = useNavigate();
  const [salariedStaffs, setSalariedStaffs] = useState([]);
  const [unSalariedStaffs, setUnSalariedStaffs] = useState([]);
  const [absentStaffs, setAbsentStaffs] = useState([]);
  const [loading, setLoading] = useState(true);

const getCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0"); // 01-12
  const day = String(now.getDate()).padStart(2, "0");        // 01-31
  return `${year}-${month}-${day}`;
};

  useEffect(() => {
    const fetchData = async () => {
      try {
        let data = {
          status: 0, // keep this based on your backend logic
        //  periodStart: "2025-01-01",
          periodStart: localStorage.getItem('initialDateForAttendance'),
         // periodEnd:getCurrentDate()
        };
        const result = await Apiservice.SalariedStaff(data);
        console.log("result.data", result.message)
        if (result.success === true) {

          setSalariedStaffs(result.data.salariedStaffs || []);
          setUnSalariedStaffs(result.data.unSalariedStaffs || []);
          setAbsentStaffs(result.data.absentStaffs);
        }
        else {
          alert(result.message);
        }
      } catch (err) {
        console.error("Error fetching staff:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handlePayment = (staff) => {
    console.log("staff At salried page", staff)
    navigate("/payslip", { state: { staff } });
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <div className="spinner-border text-primary" role="status"></div>
        <p className="mt-2">Loading staff details...</p>
      </div>
    );
  }

  return (
    <div className="container my-4">
      <h3 className="mb-4 text-center">
        {/* 💼 Salaried Staffs ({getCurrentPeriod()}) */}
      </h3>

      {/* Salaried Staffs */}
      <div className="card mb-4 shadow-sm">
        <div className="card-header bg-success text-white fw-bold">
          Paid Staffs
        </div>
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                {/* <th>Profile</th> */}
                <th>Name</th>
                <th>Role</th>
                <th>Site</th>
                <th>Mobile</th>

              </tr>
            </thead>
            <tbody>
              {salariedStaffs.length > 0 ? (
                salariedStaffs.map((staff, index) => (
                  <tr key={staff.id}>
                    <td>{index + 1}</td>
                    {/* <td>
                      <img
                        src={staff.image}
                        alt="profile"
                        className="rounded-circle"
                        width="40"
                        height="40"
                      />
                    </td> */}
                    <td>{staff.firstName + " " + staff.lastName}</td>
                    <td>
                      <span className="badge bg-primary">{staff.roleName}</span>
                    </td>
                    <td>{staff.countryCode + staff.mobileNo}</td>
                    <td>{staff.siteName}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center text-muted">
                    No salaried staff found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Unsalaried Staffs */}
      <div className="card shadow-sm">
        <div className="card-header bg-warning fw-bold">
          Pending Payment Staffs
        </div>
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                {/* <th>Profile</th> */}
                <th>Name</th>
                <th>Role</th>
                <th>Site</th>
                <th>Mobile</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {unSalariedStaffs.length > 0 ? (
                unSalariedStaffs.map((staff, index) => (
                  <tr key={staff.id}>
                    <td>{index + 1}</td>
                    {/* <td>
                      <img
                        src={staff.image}
                        alt="profile"
                        className="rounded-circle"
                        width="40"
                        height="40"
                      />
                    </td> */}
                    <td>{staff.firstName + " " + staff.lastName}</td>
                    <td>
                      <span className="badge bg-secondary">{staff.roleName}</span>
                    </td>
                    <td>{staff.siteName}</td>
                    <td>{staff.countryCode + staff.mobileNo}</td>

                    <td>
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handlePayment(staff)}
                      >
                        Pay Now
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No pending staff payments.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalariedStaffs;
